module.exports = __webpack_public_path__ + "staticcomp/img/share.4c3ed5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/12/share.jpg
// module id = hSRp
// module chunks = 39